import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { OfflineSurvey } from './common-class/survey';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'Participation.Client';
  ProductTitle: string = '';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private elementRef: ElementRef,
    private service: ParticipationDataService,
    private offlineSurvey: OfflineSurvey,
  ) {
    let path = environment.baseURL;

    this.service.emitChange(path, true);

    // Add global error handler for querySelector errors
    this.setupGlobalErrorHandler();
  }

  ngOnInit() {
    const head = document.getElementsByTagName('head')[0];
    const styleLoad = document.createElement('style');
    this.ProductTitle = environment.productName;
    styleLoad.id = 'css-loader-app';
    let loaderk12CSS =
      '.line:nth-child(1){background:#F4B639;} .line:nth-child(2){animation-delay:180ms;background:#EF5032;} .line:nth-child(3){animation-delay:360ms;background:#1860A2;} .line:nth-child(4){animation-delay:540ms;background:#63B054;}';
    let loaderCSS =
      '.line:nth-child(1){background: #006259;} .line:nth-child(2){animation-delay:180ms;background:#12bdca;} .line:nth-child(3){animation-delay:360ms;background:#20232a;} .line:nth-child(4){animation-delay:540ms;background:#83C340;}';
    if (this.ProductTitle == 'K12 Insight') {
      styleLoad.appendChild(document.createTextNode(loaderk12CSS.replace(/"/g, '')));
    } else if (this.ProductTitle == 'Sogolytics') {
      styleLoad.appendChild(document.createTextNode(loaderCSS.replace(/"/g, '')));
    }
    head.appendChild(styleLoad);
  }

  private setupGlobalErrorHandler() {
    // Override querySelector to add error handling
    const originalQuerySelector = Element.prototype.querySelector;
    const originalQuerySelectorAll = Element.prototype.querySelectorAll;
    const originalDocumentQuerySelector = Document.prototype.querySelector;
    const originalDocumentQuerySelectorAll = Document.prototype.querySelectorAll;

    // Safe querySelector for elements
    Element.prototype.querySelector = function(selector: string) {
      try {
        if (!this || !this.querySelector) {
          return null;
        }
        return originalQuerySelector.call(this, selector);
      } catch (error) {
        console.warn('Error in querySelector:', error, 'Selector:', selector);
        return null;
      }
    };

    // Safe querySelectorAll for elements
    Element.prototype.querySelectorAll = function(selector: string) {
      try {
        if (!this || !this.querySelectorAll) {
          return document.querySelectorAll('*:not(*)'); // Empty NodeList
        }
        return originalQuerySelectorAll.call(this, selector);
      } catch (error) {
        console.warn('Error in querySelectorAll:', error, 'Selector:', selector);
        return document.querySelectorAll('*:not(*)'); // Empty NodeList
      }
    };

    // Safe querySelector for document
    Document.prototype.querySelector = function(selector: string) {
      try {
        if (!this || !this.querySelector) {
          return null;
        }
        return originalDocumentQuerySelector.call(this, selector);
      } catch (error) {
        console.warn('Error in document.querySelector:', error, 'Selector:', selector);
        return null;
      }
    };

    // Safe querySelectorAll for document
    Document.prototype.querySelectorAll = function(selector: string) {
      try {
        if (!this || !this.querySelectorAll) {
          return document.querySelectorAll('*:not(*)'); // Empty NodeList
        }
        return originalDocumentQuerySelectorAll.call(this, selector);
      } catch (error) {
        console.warn('Error in document.querySelectorAll:', error, 'Selector:', selector);
        return document.querySelectorAll('*:not(*)'); // Empty NodeList
      }
    };

    // Add global error handler for unhandled errors
    window.addEventListener('error', (event) => {
      if (event.error && event.error.message && event.error.message.includes('querySelector')) {
        console.warn('Caught querySelector error:', event.error);
        event.preventDefault();
        return false;
      }
    });

    // Add global error handler for unhandled promise rejections
    window.addEventListener('unhandledrejection', (event) => {
      if (event.reason && event.reason.message && event.reason.message.includes('querySelector')) {
        console.warn('Caught querySelector promise rejection:', event.reason);
        event.preventDefault();
        return false;
      }
    });
  }
}
